/**
 * A token as a colour a non-CSS consumer can use.
 *
 * Tailwind reaches the design tokens through `rgb(var(--color-x))`, which is
 * fine for anything the stylesheet paints. MapLibre is not: its paint values
 * go to WebGL, so `var(--color-surface)` means nothing there and a hand-typed
 * hex is the obvious shortcut — and a hand-typed hex is the one thing
 * `docs/design-system.md` forbids, because it cannot follow dark mode and
 * nobody finds it when the palette changes.
 *
 * So the value is read off the document, where the tokens actually live, and
 * turned into a colour. **`rgb(var(…))` because the tokens are bare `R G B`
 * triples** — a triple is not a colour, which is the trap `markTint` fell into
 * and the reason this is a function rather than a template at each call site.
 */
export function tokenColour(name: string): string {
  if (typeof window === 'undefined') return 'rgb(255 255 255)'
  const triple = window.getComputedStyle(document.documentElement)
    .getPropertyValue(`--color-${name}`)
    .trim()
  /* Before the stylesheet has loaded, and under jsdom, there is no value. */
  return triple ? `rgb(${triple})` : 'rgb(255 255 255)'
}
